<template>
    <div>
        <v-menu offset-y>
            <template v-slot:activator="{ on }">

                <v-btn
                        :height="height"
                        icon
                        v-on="on"
                >
                    <slot>

                    </slot>

                </v-btn>

            </template>
            <v-list>
                <v-list-item
                        v-for="(item, index) in setUpList"
                        :key="index"
                        @click="clickSetUp(item)"
                >
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <!--密码修改弹框 start-->
        <v-dialog v-model="changePwdDialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">密码修改</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="changePwdForm">
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field label="原密码*"
                                                  clearable
                                                  required
                                                  v-model="changePwdFormData.oldPwd"
                                                  :rules="pwdRules"
                                                  type="password"
                                                  required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field label="新密码*"
                                                  clearable
                                                  required
                                                  v-model="changePwdFormData.newPwd"
                                                  :rules="pwdRules"
                                                  type="password"
                                                  required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field label="再次输入新密码*"
                                                  clearable
                                                  v-model="changePwdFormData.newPwd2"
                                                  :rules="newPwdRules"
                                                  required
                                                  type="password"
                                                  required></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="changePwdDialog = false">取消</v-btn>
                    <v-btn color="primary" @click="confirmPwd">确定</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--密码修改弹框 end-->

    </div>
</template>

<script>
  import scrypt from '@/utils/scrypt'

  export default {
    props:{
      height:{
        type:[String, Number],
        default:'none'
      }
    },
    name: "ZSetUp",
    data: () => ({
      setUpList: [
        {
          label: '退出登录',
          id: '00'
        },
        // {
        //   label: '修改密码',
        //   id: '01'
        // },
      ],
      changePwdDialog: false,
      changePwdFormData: {
        oldPwd: '',
        newPwd: '',
        newPwd2: ''
      },
      pwdRules: [
        v => !!v || '必输哦~',
        v => /^(\w){6,20}$/.test(v) || '请输入6至20位数字字母组成的密码',
      ],
    }),
    computed: {
      newPwdRules() {
        var rules =
          [
            v => !!v || '必输哦~',
            v => v == this.changePwdFormData.newPwd || '两次密码输入不同',
            v => /^(\w){6,20}$/.test(v) || '请输入6至20位数字字母组成的密码',
          ];
        return rules;
      },
    },
    methods: {
      clickSetUp(item) {
        // console.log(item,'当前点击的菜单');
        if (item.id == '00') {
          // 退出登录
          this.$store.dispatch('logOut').then(() => {
            //location.reload()// In order to re-instantiate the vue-router object to avoid bugs
            this.$router.push({path: '/'})
            location.reload()
          })
        }
        if (item.id == '01') {
          // 修改密码
          this.changePwdDialog = true;
        }
      },
      confirmPwd() {
        if (this.$refs.changePwdForm.validate()) {
          console.log(this.changePwdFormData);
          var reqData = {};
          reqData.oldPwd = scrypt.Encrypt(this.changePwdFormData.oldPwd);
          reqData.newPwd = scrypt.Encrypt(this.changePwdFormData.newPwd);
          reqData.newPwd2 = scrypt.Encrypt(this.changePwdFormData.newPwd2);
          // 接口调用
          this.$refs.changePwdForm.reset();
          this.changePwdDialog = false;
        }
      }
    }
  }
</script>

<style scoped>

</style>